import axios from "@/axios.js"

export default {
  createStudents({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/student/signup", data)
        .then((response) => {
          // commit('SET_STUDENTS', response.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  studentsMonthWiseRegistation({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/monthWise/student")
        .then((response) => {
          var seriesY = [];
          var seriesX = [];
          for (const entry of response.data){
            seriesX.push(entry.month_text+" "+entry.year)
            seriesY.push(entry.students)
          }

          commit('SET_STUDENTS_REGISTATION_X', seriesX)
          commit('SET_STUDENTS_REGISTATION_Y', seriesY)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchStudents({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/student")
        .then((response) => {
          commit('SET_STUDENTS', response.data)
          commit('SET_STUDENTS_COUNT', response.data.length)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchStudent({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/student/"+userId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchStudentLogbokClasses({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/studentLogbokClass", {student_id : userId})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchStudentHeyWayClasses({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/studentFullClasses", {student_id : userId})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getTimeByLocation({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/booking_2/admin/getTimeByLocation", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getTimeByTeacher({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/booking_2/admin/getTimeByTeacher", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  bookClassByLocation({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/booking_2/admin/bookClass", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  confirmCancelClassByAdmin({ commit }, booking_id) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/student_class/admin_cancel", {student_bookings_id : booking_id})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  confirmCancelClassByTeacher({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/student_class/teacher_cancel", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  confirmCancelClassByStudent({ commit }, booking_id) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/student_class/student_cancel", {student_bookings_id : booking_id})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateStudentSign({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/student_class/studentSignature", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchUnreadNotificationCount({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/getUnreadMessageCount")
        .then((response) => {
          commit('SET_UNREAD_NOTIFICATIONS', response.data.total_unread_notification) 
          commit('SET_UNREAD_CHATS', response.data.total_unread_message) 
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchNotification({ commit }, page) {
    return new Promise((resolve, reject) => {
      if(!page) page = 1
      axios.get("/api/admin/notification?page="+page)
        .then((response) => {
          commit('SET_NOTIFICATIONS', response.data) 
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  fetchStudentLogbokClassesForPackage({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/studentClassLog", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateStudent({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/student/"+data.student_id, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updateUserStatus({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/student/status/"+data.student_id, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  deleteStudent({ commit }, studentId) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/admin/studentDelete/"+studentId)
        .then((response) => {
          commit('REMOVE_STUDENT', studentId)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },

  createTeachers({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/teacher/signup", data)
        .then((response) => {
          // commit('SET_STUDENTS', response.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updateTeacher({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/teacher/"+data.id, data.formData)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  fetchTeachers({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/teacher")
        .then((response) => {
          commit('SET_TEACHERS', response.data)
          commit('SET_TEACHERS_COUNT', response.data.length)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchIntenalExternalTeachers({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/teachers")
        .then((response) => {
          commit('SET_INTERNAL_EXTERNAL_TEACHERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchTeacher({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/teacher/"+userId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchTeacherSignature({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewTeacherSignature", {teacher_id : userId})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  //new teacher time slots
  createTeacherTime({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/createSchludeArray", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error.response)  })
    })
  },
  deleteTeacherTime({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/deleteSchludeArray", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  // createTeacherTime({ commit }, data) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/admin/calender/teacher/create", data)
  //       .then((response) => {
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  //new teacher time slots
  fetchTeacherTime({ commit }, teacherId) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/schludeArray", { teacher_id : teacherId})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  // fetchTeacherTime({ commit }, teacherId) {
  //   return new Promise((resolve, reject) => {
  //     axios.get("/api/admin/calender/teacher/"+teacherId)
  //       .then((response) => {
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  uploadTeacherSignatureImage({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/uploadTeacherSignature", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteTeacher({ commit }, teacherId) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/admin/teacherDelete/"+teacherId)
        .then((response) => {
          commit('REMOVE_TEACHER', teacherId)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },


  recoverPassword({ commit }, email) {
    return new Promise((resolve, reject) => {
      axios.post("/api/auth/recovery", {email : email})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updateProfile({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/profile", data)
        .then((response) => {
          commit('UPDATE_USER_INFO', response.data.user, {root: true})
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updatePassword({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/changePassword", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updateClub({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/club", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updateClubSetting({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/club/setting", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
}
